import React from "react";

import styled from "styled-components/macro";

import FnrIcon from "UI/FnrIcon";

import { SplashWrapper } from "./styles";

export default function CloseButton({ show, handleClose }) {
  if (!show) return null;
  return (
    <Wrapper>
      <Button onClick={handleClose}>
        <FnrIcon fas fa-times-circle />
      </Button>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: absolute;

  z-index: 500;
  top: 4px;
  right: 4px;
`;

const Button = styled.button`
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  appearance: none;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  color: white;
  opacity: 0.8;
  font-size: 18px;
  opacity: 0;
  transition: opacity 0.2s, transform 0.2s;

  ${SplashWrapper}:hover & {
    opacity: 0.5;
  }
  @media screen and (hover: none) {
    opacity: 0.5;
  }

  &:hover {
    cursor: pointer;
    opacity: 0.8 !important;
    transform: scale(1.05);
  }
  &:active {
    transform: scale(0.95);
    opacity: 1 !important;
  }
`;
